import {uuid} from 'vue-uuid';

export default class MenuItem {
  uuid = uuid.v4();
  path = '';
  text = '';
  icon = '';
  weight = 0;
  permission = null;
  extraPathsToLeaveCollapsed = []
  show = null

  constructor(path, text, weight = 0, icon = '', children = [], permission = '', extraPathsToLeaveCollapsed = [], show=null) {
    this.path = path;
    this.text = text;
    this.weight = weight;
    this.icon = icon;
    this.children = children;
    this.permission = permission;
    this.extraPathsToLeaveCollapsed = extraPathsToLeaveCollapsed;
    this.show = show;
  }
}
